import React, { useState } from "react";
import PropTypes from "prop-types";
import api from "../api/api"; // Axios instance
import { capex_lifespans } from "../data/inputData";
import { PrimaryButtonStyled, SecondaryButtonStyled } from "../styles/Button";
import { FormNavContainerStyled } from "../styles/Form";
import logger from "../logger/logger";
import { useNavigate } from 'react-router-dom'
import { PageHeader2Styled, PageHeaderSubTextStyled } from "../styles/Main";

const SubmitForm = ({ mode, handleDecrementFormStep, formData, zipCodes, setResults }) => {
  const navigate = useNavigate();
  const [calculationError, setCalculationError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const validateForm = () => {
    return true
  };

  const createPropertyDetails = () => {
    let newFormData = {}
    Object.keys(formData).forEach((zipKey) => {
      newFormData[zipKey] = {}
      Object.keys(formData[zipKey]).forEach((metricKey) => {
        newFormData[zipKey][metricKey] = formData[zipKey][metricKey]['value']
      })
    })
    return newFormData
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    let payload = {
      mode,
      zip_codes: zipCodes,
      capex_lifespans,
      form_data: createPropertyDetails()
    };
    try {
      setIsLoading(true);
      setCalculationError(false);
      const response = await api.post("/calculate", payload);
      console.log(response.data)
      setResults(response.data);
      navigate("/results");
      logger.info("Form submitted successfully and received results.");
    } catch (error) {
      setIsLoading(false);
      console.error("Error:", error);
      logger.error("Form submission failed:", error);
      setCalculationError(true);
      alert("Failed to connect to the backend!");
    } finally {
      setIsLoading(false);
    }

  };

  return (
    <div>
      <PageHeader2Styled>Verify Analysis Inputs</PageHeader2Styled>
      <PageHeaderSubTextStyled>Ready to submit?</PageHeaderSubTextStyled>
      <PageHeaderSubTextStyled>Please confirm all inputs are correct.</PageHeaderSubTextStyled>
      {calculationError && (
        <div style={{ color: 'red', marginBottom: '1rem' }}>Failed to calculate. Please try again.</div>
      )}
      <form onSubmit={handleSubmit}>

        <FormNavContainerStyled>
          <SecondaryButtonStyled onClick={handleDecrementFormStep}>Back</SecondaryButtonStyled>
          <PrimaryButtonStyled type="submit" disabled={isLoading}>
            {isLoading ? 'Calculating...' : 'Submit'}
          </PrimaryButtonStyled>
        </FormNavContainerStyled>
        
      </form>
    </div>
  );
};

SubmitForm.propTypes = {
    mode: PropTypes.string.isRequired, 
    handleDecrementFormStep: PropTypes.func.isRequired, 
    formData: PropTypes.object.isRequired,
    zipCodes: PropTypes.array.isRequired,
};

export default SubmitForm;